import styled from '@emotion/styled';

export const Container = styled.div`
  display: flex;
  background-color: ${({ theme }) => theme.colors.grey300};
  border-radius: 10px;
  border-left: 5px solid ${({ theme }) => theme.colors.primaryBlue};
`;

interface ImageBoxProps extends React.HTMLAttributes<HTMLDivElement> {
  image: string | undefined;
}

export const ImageBox = styled.div<ImageBoxProps>`
  flex-basis: 35%;
  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top;
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
  /* aspect-ratio: 1; */
`;

export const InfoWrapper = styled.div`
  padding: 16px;
  flex-basis: 65%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  justify-content: space-between;
`;

export const Title = styled.div`
  font-size: 17px;
  font-family: NokiaPureHeadline-Bold;
  color: ${({ theme }) => theme.colors.blueBlack};
  display: -webkit-box;
  margin-top: -3px;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

export const BtnsWrapper = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
`;
